<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    preserveAspectRatio="xMinYMin meet"
    class="icon"
  >
    <g>
      <path
        d="M2,25c0,12.683,10.317,23,23,23s23-10.317,23-23S37.683,2,25,2S2,12.317,2,25z M26,12v18h6l-7,7l-7-7h6V12H26z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "arrow-up"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
